import { createSelector } from '@reduxjs/toolkit';

const mapState = (state) => state.map;

// Retrieve the Map state specific objects
export const selectGoogleMap = createSelector(mapState, (map) => map.googleMap);
export const selectCenter = createSelector(mapState, (map) => map.config.center);
export const selectZoom = createSelector(mapState, (map) => map.config.zoom);
export const selectRoute = createSelector(mapState, (map) => map.route);
